package br.com.texeratx.boardgametimeapp.domain.usecases.player

import br.com.texeratx.boardgametimeapp.data.repository.PlayerRepository
import br.com.texeratx.boardgametimeapp.ui.screens.games.model.PlayerOwnerUI

class GetPlayersNameUseCase(
    private val repository: PlayerRepository
) {

    suspend operator fun invoke(): Result<List<PlayerOwnerUI>> {
        return repository.getPlayersName().map { list ->
            list.map {
                PlayerOwnerUI(
                    id = it.id,
                    name = it.name
                )
            }
        }
    }
}
